export const money = (price) => {
  return (price / 100.0).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')
}
